import { Injectable } from '@angular/core';
import { TranslationService } from '@schoolbelle/common/translation';
import { FacesTranslationComponent } from './faces-translation.component';

@Injectable({
  providedIn: 'root',
})
export class FacesTranslationService {
  constructor(private translationService: TranslationService) {
    this.translationService.injectComponent(FacesTranslationComponent);
  }
}
